export default {
	mother: "MOTHER WALLET",
	prefunded: "Channel Wallet",
	bonded: "Channel Wallet",
	cws: "Product Wallet",
	"": "",
};
